import React, { useEffect, useState } from 'react';
import { FirebaseApp, initializeApp } from 'firebase/app';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { rest, useUserInfo, LoadingIndicator } from '@xolv-mybrightlink/common';
import { useFirebaseApp } from './useFirebaseApp';
import { FirebaseRemoteConfigProvider } from './FirebaseRemoteConfigProvider';
import { Box } from '@mui/material';

const firebaseConfig = {
  apiKey: __JS_ENV_VARS__['JS_ENV_FIREBASE_API_KEY'],
  authDomain: __JS_ENV_VARS__['JS_ENV_FIREBASE_AUTH_DOMAIN'],
  databaseURL: __JS_ENV_VARS__['JS_ENV_FIREBASE_DB_URL'],
  projectId: __JS_ENV_VARS__['JS_ENV_FIREBASE_PROJECT_ID'],
  storageBucket: __JS_ENV_VARS__['JS_ENV_FIREBASE_STORAGE_BUCKET'],
  messagingSenderId: __JS_ENV_VARS__['JS_ENV_FIREBASE_SENDER_ID'],
  appId: __JS_ENV_VARS__['JS_ENV_FIREBASE_APP_ID'],
  measurementId: __JS_ENV_VARS__['JS_ENV_FIREBASE_MEASUREMENT_ID'],
};

export const FbContext = React.createContext<FirebaseApp | null>(null);

type FirebaseAuthenticatedProps = {
  children: React.ReactNode;
  loading?: React.ReactElement;
};

const AuthenticateFirebase = (props: FirebaseAuthenticatedProps) => {
  const [ready, setReady] = useState(false);
  const firebaseApp = useFirebaseApp();
  const userInfo = useUserInfo();
  useEffect(() => {
    const authenticate = async () => {
      const currentUserGuid = userInfo.guid;
      const firebaseAuth = getAuth(firebaseApp);
      let fbCurrentUser = firebaseAuth.currentUser;

      if (
        !fbCurrentUser?.isAnonymous &&
        currentUserGuid &&
        fbCurrentUser?.uid !== currentUserGuid
      ) {
        await firebaseAuth.signOut();
        fbCurrentUser = firebaseAuth.currentUser;
      }

      if (!fbCurrentUser || fbCurrentUser.isAnonymous) {
        const token = await getFirebaseToken();
        const fbUser = await signInWithCustomToken(firebaseAuth, token);
        console.log('firebase user', fbUser.user.toJSON());
      }

      setReady(true);
    };
    authenticate();
  }, [firebaseApp, userInfo.guid]);
  return ready ? (
    <>{props.children}</>
  ) : (
    props.loading ?? (
      <Box sx={{ height: '100vh' }}>
        <LoadingIndicator fullHeight></LoadingIndicator>
      </Box>
    )
  );
};

export const FirebaseAuthenticated = (props: FirebaseAuthenticatedProps) => {
  return (
    <FbContext.Provider
      value={initializeApp(firebaseConfig, 'myBrightlink_web')}
    >
      <AuthenticateFirebase loading={props.loading}>
        <FirebaseRemoteConfigProvider>
          {props.children}
        </FirebaseRemoteConfigProvider>
      </AuthenticateFirebase>
    </FbContext.Provider>
  );
};

const getFirebaseToken = async (): Promise<string> => {
  const accessToken = localStorage.getItem('access_token');
  const { data } = await rest.post<{ firebaseToken: string }>(
    '/user/chat-tokens',
    {
      device_id: 'myBrightlink_web',
    },
    { headers: { Authorization: `Bearer ${accessToken}` } },
  );
  return data.firebaseToken;
};
